module.exports = __webpack_public_path__ + "static/img/4370_phase_function_Paper_PointsHejduk_Prediction.efc5a90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4370_phase_function_Paper_PointsHejduk_Prediction.png
// module id = A0Px
// module chunks = 0